document.addEventListener('DOMContentLoaded', () => {
    initElektrarnaDetail();
});

function initElektrarnaDetail() {
    const el = document.querySelector('#updateElektrarnaDetailData');
    if (!el) {
        return;
    }

    const detail = new ElektrarnaDetail();
    detail.init();
}

class ElektrarnaDetail {

    constructor() {
        this.isProcessing = false;
    }

    init() {
        setInterval(() => {
            this.update();
        }, 1000);
    }

    update() {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;

        naja.makeRequest('GET', document.querySelector('#updateElektrarnaDetailData').value, null, {
            history: false
        }).then(() => {
            this.isProcessing = false;
        }).catch(error => {
            console.error('Chyba při aktualizaci dat elektrárny:', error);
            this.isProcessing = false;
        });
    }
}
